<template>
  <div>
    <div>
      <!--这里是要展示的内容层-登录-->
      <div class="login" v-show="popup==0">
        <img src="../../assets/img/dlbg.png" alt />
        <div class="right">
          <img class="close" src="../../assets/img/xx.png" alt @click="closepopup" />
          <div class="title">登录开始学习</div>
          <div class="phone">手机号</div>
          <input type="text" v-model="form.phone" class="int" placeholder="请输入手机号" />
          <div class="Password">密码</div>
          <input
            type="password"
            v-model="form.password"
            @keyup.enter="login(form)"
            class="int"
            placeholder="请输入密码"
          />
          <div class="bottom">
            <div class="register" @click="register">没有账号？立即注册</div>
            <div class="forget" @click="forget">忘记密码？</div>
          </div>
          <div class="btn" @click="login(form)">立即登录</div>
          <div class="register1" @click="goweixin">
            APP扫码登录
            <img src="../../assets/img/r1.png" alt />
          </div>
        </div>
      </div>
      <!-- 注册1 -->
      <div>
        <div class="login" v-show="popup==2">
          <img src="../../assets/img/dlbg.png" alt />
          <div class="right">
            <img class="close" src="../../assets/img/xx.png" alt @click="closepopup" />
            <div class="phone">注册手机号</div>
            <input type="text" class="int" v-model="phone1" placeholder="请输入手机号" />
            <div class="Password">验证码</div>
            <div class="yzm">
              <input type="text" class="yzm-i" v-model="code" placeholder="请输入密码" />
              <div class="yzm-btn" v-show="show" @click="getyzm">获取验证码</div>
              <div class="yzm-btn djs" v-show="!show">{{count}}s后获取</div>
            </div>
            <div class="Password">邀请码（选填）</div>
            <input type="text" v-model="invitation" class="int" placeholder="请输入邀请码" />
            <div class="btn" @click="next1">下一步</div>
            <div class="bot">
              <img src="../../assets/img/u.png" alt />
              <span class="fanhui" @click="goback">返回</span>
              <div class="bot-r">
                <input v-model="isAgreen" @click="check(isAgreen)" type="checkbox" name="agreement" />
                <div class="ty">
                  同意
                  <span class="xieyi" @click="goxy(5)">《知会教育中心使用协议》</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 注册2 -->
      <div class="login" v-show="popup==3">
        <img src="../../assets/img/dlbg.png" alt />
        <div class="right">
          <img class="close" src="../../assets/img/xx.png" alt @click="closepopup" />
          <div class="phone">设置密码</div>
          <input type="password" class="int" v-model="inputint" placeholder="请输入登录密码" />
          <div class="Password">确认密码</div>
          <input type="password" class="int" v-model="inputint1" placeholder="再次输入登录密码" />
          <div class="btn1" @click="confirm">确认注册</div>
          <div class="bot">
            <img src="../../assets/img/u.png" alt />
            <span class="fanhui" @click="goback2">返回</span>
            <div class="bot-r">
              <input type="checkbox" v-model="isAgreen" @click="check(isAgreen)" name="agreement" />
              <div class="ty">
                同意
                <span class="xieyi">《知会教育中心使用协议》</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 密码找回1 -->
      <div class="login" v-show="popup==4">
        <img src="../../assets/img/dlbg.png" alt />
        <div class="right">
          <img class="close" src="../../assets/img/xx.png" alt @click="closepopup" />
          <div class="title">找回密码</div>
          <div class="phone">手机号</div>
          <input type="text" class="int" v-model="phone2" placeholder="请输入手机号" />
          <div class="Password">验证码</div>
          <div class="yzm">
            <input type="text" class="yzm-i" v-model="code2" placeholder="请输入密码" />
            <div class="yzm-btn" v-show="show" @click="getcode">获取验证码</div>
            <div class="yzm-btn djs" v-show="!show">{{count}}s后获取</div>
          </div>
          <div class="btn2" @click="next2">下一步</div>
          <div class="bot">
            <img src="../../assets/img/u.png" alt />
            <span class="fanhui" @click="goback">返回</span>
          </div>
        </div>
      </div>
      <!-- 密码找回2 -->
      <div class="login" v-show="popup==5">
        <img src="../../assets/img/dlbg.png" alt />
        <div class="right">
          <img class="close" src="../../assets/img/xx.png" alt @click="closepopup" />
          <div class="title">重设密码</div>
          <div class="phone">新密码</div>
          <input type="Password" class="int" v-model="newpassword" placeholder="请输入密码" />
          <div class="Password">确认新密码</div>
          <input type="Password" class="int" v-model="newpassword1" placeholder="请输入密码" />
          <div class="btn3" @click="complete">完成</div>
          <div class="bot">
            <img src="../../assets/img/u.png" alt />
            <span class="fanhui" @click="goback1">返回</span>
          </div>
        </div>
      </div>
      <!-- 二维码登陆 -->
      <div class="login" v-show="popup==6">
        <img src="../../assets/img/dlbg.png" alt />
        <div class="right">
          <img class="close" src="../../assets/img/xx.png" alt @click="closepopup" />
          <div class="title1">登录开始学习</div>
          <div class="qrCode">
            <div id="qrCode" ref="qrCodeDiv" @click="shuaxin"></div>
            <br />
            <div>请使用手机APP扫码</div>
          </div>
          <div class="bot">
            <img src="../../assets/img/u.png" alt />
            <span class="fanhui1" @click="goback3">返回</span>
          </div>
        </div>
      </div>
    </div>

    <!--这里是半透明背景层-->
    <div class="over" v-show="popup!=1"></div>
  </div>
</template>

<script>
import { register } from "@/service/service";
import QRCode from "qrcodejs2";
export default {
  // 无感刷新引入
  inject: ["reload"],
  props: ["title"], //父组件调用子组件时给子组件传值
  data() {
    return {
      popup: 0,
      // 登录
      form: {
        phone: "",
        password: "",
      },
      // 注册
      phone1: "",
      code: "",
      code1: "",
      isAgreen: false,
      // 注册密码
      inputint: "",
      inputint1: "",
      invitation: "",
      // 找回密码
      phone2: "",
      code2: "",
      newpassword: "",
      newpassword1: "",
      dialogVisible: false,
      show: true,
      count: "",
      timer: null,
      zixun: "",
      timer: "",
    };
  },
  mounted() {
    this.zixun = this.title;
  },
  created() {
    // console.log(this.$md5("hhhahaah"));
    // console.log( this.home.title )
  },
  methods: {
    goxy(i) {
      this.$router.push({
        path: "/xy",
        query: {
          id: i,
        },
      });
    },
    //    确认框
    handleClose(done) {
      this.$confirm("请同意知会教育中心使用协议")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleClose1(done) {
      this.$confirm("手机号或验证码不能为空")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleClose2(done) {
      this.$confirm("验证码错误")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleClose3(done) {
      this.$confirm("请输入相同的密码")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleClose4(done) {
      this.$confirm("手机号格式错误")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleClose5(done) {
      this.$confirm("手机号已存在")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleClose6(done) {
      this.$confirm("账号或密码错误")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    open1() {
      this.$notify({
        title: "成功",
        message: "登录成功",
        type: "success",
      });
    },
    open2() {
      this.$notify({
        title: "成功",
        message: "修改成功",
        type: "success",
      });
    },
    open3() {
      this.$notify({
        title: "成功",
        message: "注册成功",
        type: "success",
      });
    },
    //    同意
    check: function (item) {
      this.isAgreen = !item;
    },
    //    登录
    async login(information) {
      await this.$service.home
        .login({
          phone: information.phone,
          password: information.password,
        })
        .then((res) => {
          console.log(res.data)
          if (res.data) {
            if (res.data.code == 200) {
              sessionStorage.setItem("data", JSON.stringify(res.data.content));
              sessionStorage.setItem("if_phone", res.data.content.if_phone);
              this.open1();
              this.popup = 1;
              this.reload();
            }
          }
          if (res.err) {
            if (res.err.data.code == 201) {
              this.handleClose6();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 找回密码 发验证码
    async getcode() {
      var phone2 = this.phone2;
      if (
        !/^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/.test(
          this.phone2
        )
      ) {
        this.handleClose4();
        return false;
      } else {
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        await this.$service.home
          .getyzm({
            phone: phone2,
            type: 0,
          })
          .then((res) => {
            console.log(res);
            if (res.data) {
              if (res.data.code == 200) {
                this.code1 = res.data.content;
              }
            }
            if (res.err) {
              if (res.err.data.code == 201) {
                this.$confirm(res.err.data.msg)
                  .then((_) => {
                    done();
                  })
                  .catch((_) => {});
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 找密码下一步验证 验证码
    async next2() {
      var phone2 = this.phone2;
      var code = this.code2;
      // console.log(phone2, code);
      if (phone2 && code) {
        await this.$service.home
          .ifcode({
            phone: phone2,
            code: code,
          })
          .then((res) => {
            console.log(res);
            if (res.data) {
              if (res.data.code == 200) {
                this.popup = 5;
              }
            }
            if (res.err) {
              if (res.err.data.code == 201) {
                this.handleClose2();
              }
            }
          })
          .catch((err) => {});
      } else {
        this.handleClose1();
      }
    },
    //  完成修改
    async complete() {
      var phone = this.phone2;
      var newpassword = this.newpassword;
      var newpassword1 = this.newpassword1;
      // console.log(phone);
      if (newpassword.length < 6 || newpassword.length > 12) {
        this.$confirm("密码为6-12位哦")
          .then((_) => {
            done();
          })
          .catch((_) => {});
        return false;
      }
      if (newpassword == newpassword1) {
        await this.$service.home
          .backpassword({
            phone: phone,
            password: newpassword,
          })
          .then((res) => {
            // console.log(res);
            if (res.data) {
              if (res.data.code == 200) {
                this.open2();
                this.popup = 0;
              }
            }
          })
          .catch((err) => {
            console.log(err.response);
          });
      } else {
        this.handleClose3();
      }
    },
    // 注册验证码获取
    async getyzm() {
      if (
        !/^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8,5])|(19[7]))\d{8}$/.test(
          this.phone1
        )
      ) {
        this.handleClose4();
        return false;
      } else {
        const TIME_COUNT = 60;
        var phone1 = this.phone1;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        await this.$service.home
          .getyzm({
            phone: phone1,
            type: 1,
          })
          .then((res) => {
            // console.log(res);
            if (res.data) {
              if (res.data.code == 200) {
                this.code1 = res.data.content;
              }
            }
            if (res.err) {
              if (res.err.data.code == 201) {
                this.handleClose5();
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 注册下一步
    async next1() {
      var phone2 = this.phone1;
      var code = this.code;
      var check = this.isAgreen;
      // console.log(phone2, code, check);
      if (check == true) {
        if (phone2 && code) {
          await this.$service.home
            .ifcode({
              phone: phone2,
              code: code,
            })
            .then((res) => {
              // console.log(res);
              if (res.data) {
                if (res.data.code == 200) {
                  this.popup = 3;
                }
              }
              if (res.err) {
                if (res.err.data.code == 201) {
                  this.handleClose2();
                }
              }
            })
            .catch((err) => {});
        } else {
          this.handleClose1();
        }
      } else {
        this.handleClose();
      }
    },
    // 完成注册
    async confirm() {
      var inputint = this.inputint;
      var inputint1 = this.inputint1;
      var phone3 = this.phone1;
      var invitation = this.invitation;
      var check = this.isAgreen;
      // console.log(inputint);
      if (inputint.length < 6 || inputint.length > 12) {
        this.$confirm("密码为6-12位哦")
          .then((_) => {
            done();
          })
          .catch((_) => {});
        return false;
      }
      if (check == true) {
        if (inputint === inputint1) {
          await this.$service.home
            .register({
              phone: phone3,
              password: inputint,
              invite_code: invitation,
            })
            .then((res) => {
              this.open3();
              this.popup = 0;
              // console.log(res);
            })
            .catch((err) => {
              console.log(err.response);
            });
        } else {
          this.handleClose3();
        }
      } else {
        this.handleClose();
      }
    },
    //说明 0=登录 1=关闭 2=注册1 3=注册2 4=密码找回1 5=密码找回2
    //关闭弹窗
    closepopup() {
      if (this.zixun == 1) {
        this.$router.push({
          path: "/",
        });
      } else {
        this.popup = 1;
        // 页面无感刷新
        this.reload();
        clearInterval(this.timer);
      }
    },
    // 没有账号 立即注册
    register() {
      this.popup = 2;
    },
    // 忘记密码
    forget() {
      this.popup = 4;
    },
    //  找密码1和注册1返回
    goback() {
      this.popup = 0;
    },
    //找密码2返回
    goback1() {
      this.popup = 4;
    },
    //二维码登陆返回
    goback3() {
      this.popup = 0;
      clearInterval(this.timer);
    },
    //  注册2返回
    goback2() {
      this.popup = 2;
    },
    // 二维码过期刷新
    shuaxin() {
      clearInterval(this.timer);
      this.goweixin();
    },
    // 微信登陆
    async goweixin() {
      this.popup = 6;
      let biaoshi =
        (Math.random() * 10000000).toString(16).substr(0, 4) +
        "-" +
        new Date().getTime() +
        "-" +
        Math.random().toString().substr(2, 5);
      document.getElementById("qrCode").innerHTML = "";
      new QRCode(this.$refs.qrCodeDiv, {
        text: biaoshi,
        width: 160,
        height: 160,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
      this.timer = setInterval(() => {
        this.$service.home
          .loginscan({
            scan_code: biaoshi,
          })
          .then((res) => {
            if (res.data) {
              if (res.data.code == 200) {
                sessionStorage.setItem(
                  "data",
                  JSON.stringify(res.data.content)
                );
                 sessionStorage.setItem("if_phone", res.data.content.if_phone);
                this.open1();
                this.popup = 1;
                this.reload();
                clearInterval(this.timer);
              }
            }
          });
      }, 3000);
      setTimeout(() => {
        clearInterval(this.timer);
        document.getElementById("qrCode").innerHTML = "已过期点我刷新";
      }, 180000);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.qrCode {
  width: 160px;
  height: 160px;
  margin: 0 auto;
  text-align: center;
}
#qrCode {
  width: 160px;
  height: 160px;
  margin: 0 auto;
  text-align: center;
  line-height: 160px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(20, 133, 238, 1);
}
.login {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 680px;
  height: 400px;
  background: rgba(255, 255, 255, 1);
  display: flex;
}
.over {
  position: fixed;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #111111;
}
.login .right {
  margin-left: 62px;
  margin-top: 16px;
}
.login .right .yzm {
  display: flex;
  margin-bottom: 16px;
}
input::-webkit-input-placeholder {
  padding-left: 10px;
}
.login .right input.int {
  background-color: #f8f8f8;
  width: 280px;
  height: 36px;
  border-radius: 6px;
  border: none;
  margin-bottom: 16px;
}
.login .right .bottom {
  display: flex;
  margin-bottom: 28px;
  justify-content: space-between;
  align-items: center;
  width: 280px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(20, 133, 238, 1);
}
.login .right input.yzm-i {
  width: 168px;
  height: 36px;
  margin-right: 12px;
  background-color: #f8f8f8;
  border-radius: 6px;
  border: none;
}
.login .right .yzm-btn {
  width: 100px;
  height: 36px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  color: #ffffff;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
}
.login .right .djs {
  background-color: #ccc;
}
.login .right .close {
  margin-left: 306px;
}
.login .right .title {
  font-size: 24px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 22px;
}
.login .right .title1 {
  font-size: 24px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  margin-bottom: 22px;
}
.login .right .phone,
.login .right .Password {
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  margin-bottom: 6px;
}
/* .login .right .forget {
  font-size: 14px;
  font-weight: 500;
  color: rgba(20, 133, 238, 1);
  margin-left: 210px;
  margin-bottom: 26px;
} */
.login .right .btn {
  width: 280px;
  height: 46px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  text-align: center;
  line-height: 46px;
  color: #ffffff;
  margin-bottom: 10px;
}
.login .right .register1 {
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 117, 239, 1);
  margin-left: 172px;
}
/* 注册1 */
.login .right .bot {
  display: flex;
  margin-top: 12px;
}
.login .right .bot .fanhui {
  font-size: 12px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  margin-left: 1px;
}
.login .right .bot img {
  margin-top: 100px;
}
.login .right .bot .fanhui1 {
  font-size: 12px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  margin-top: 100px;
}
.login .right .bot .bot-r {
  display: flex;
  font-size: 12px;
  font-weight: 500;
  margin-left: 62px;
}
.login .right .bot .ty {
  color: rgba(136, 136, 136, 1);
}
.login .right .bot .xieyi {
  color: #1775ef;
}
/* 注册2 */
.login .right .btn1 {
  width: 280px;
  height: 46px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  text-align: center;
  line-height: 46px;
  color: #ffffff;
  margin-bottom: 10px;
  margin-top: 106px;
}
/* 找回密码1 */
.login .right .btn2 {
  width: 280px;
  height: 46px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  text-align: center;
  line-height: 46px;
  color: #ffffff;
  margin-bottom: 10px;
  margin-top: 56px;
}
/* 找回密码2 */
.login .right .btn3 {
  width: 280px;
  height: 46px;
  background: rgba(23, 117, 239, 1);
  border-radius: 6px;
  text-align: center;
  line-height: 46px;
  color: #ffffff;
  margin-bottom: 10px;
  margin-top: 56px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/login.vue